// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Live Betting Page Styles */

/* Custom Layout Structure - Match Homepage Layout */
.live-betting-layout {
  display: flex;
  min-height: calc(100vh - 80px);
  max-width: 1600px;
  margin: 0 auto;
  width: 100%;
}

.live-betting-main-content {
  width: calc(100% - 27rem);
  background-color: var(--bg-primary);
  padding: var(--spacing-lg);
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: var(--spacing-lg);
}

.live-betting-right-sidebar {
  width: 27rem;
  background-color: var(--bg-secondary);
  border-left: 1px solid var(--border-primary);
  padding: var(--spacing-lg);
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: var(--spacing-lg);
}

.tournament-selection-section {
  flex-shrink: 0;
}

.available-players-section {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.tournament-list-vertical {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-sm);
  flex: 1 1;
  overflow-y: auto;
}

.tournament-card-sidebar {
  background-color: var(--bg-card);
  border: 1px solid var(--border-primary);
  border-radius: var(--radius-md);
  padding: var(--spacing-md);
  cursor: pointer;
  transition: all var(--transition-fast);
  position: relative;
}

.tournament-card-sidebar:hover {
  border-color: var(--proskins-green);
  box-shadow: 0 2px 8px rgba(0, 255, 136, 0.1);
}

.tournament-card-sidebar.selected {
  border-color: var(--proskins-green);
  background-color: rgba(0, 255, 136, 0.05);
  box-shadow: 0 2px 8px rgba(0, 255, 136, 0.2);
}

.tournament-name-sidebar {
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--text-primary);
  margin: 8px 0 0 0;
  line-height: 1.2;
}

/* Main Content Styles */
.live-betting-main {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-lg);
  height: 100%;
}

/* Connection Status Styles */
.connection-status {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin: 0 1rem;
}

.connection-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  transition: all var(--transition-fast);
}

.connection-dot.connected {
  background-color: var(--proskins-green);
  box-shadow: 0 0 8px rgba(0, 255, 136, 0.5);
}

.connection-dot.disconnected {
  background-color: var(--text-muted);
}

.connection-text {
  font-size: 0.75rem;
  font-weight: 500;
  color: var(--text-secondary);
}

/* Right Sidebar Styles */
.available-players-sidebar {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-md);
  height: 100%;
}

.available-players-list {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-sm);
  flex: 1 1;
  overflow-y: auto;
}

.player-item-sidebar {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-sm);
  padding: var(--spacing-md);
  border: 1px solid var(--border-secondary);
  border-radius: var(--radius-md);
  background-color: var(--bg-tertiary);
  transition: all var(--transition-fast);
}

.player-item-sidebar:hover {
  border-color: var(--border-accent);
  transform: translateY(-1px);
  box-shadow: var(--shadow-md);
}

.player-item-sidebar .player-info {
  flex: 1 1;
}

.player-item-sidebar .player-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 4px;
}

.player-item-sidebar .player-name {
  font-weight: 500;
  color: var(--text-primary);
  margin: 0;
  font-size: 0.875rem;
}

.player-item-sidebar .player-details {
  font-size: 0.75rem;
  color: var(--text-secondary);
  margin-bottom: var(--spacing-sm);
}

.player-item-sidebar .player-price-section {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--spacing-sm);
}

.player-item-sidebar .player-price {
  font-size: 1rem;
  font-weight: 700;
  color: var(--proskins-green);
}

.player-item-sidebar .purchase-button {
  padding: 6px 12px;
  font-size: 0.75rem;
  font-weight: 500;
  border-radius: 6px;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
  flex-shrink: 0;
}



/* Header */
.live-betting-header {
  margin-bottom: 0;
}

.live-betting-title-section {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: var(--spacing-lg);
}

.live-betting-title-left {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-sm);
}

.live-betting-title {
  font-size: 2rem;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0;
}

.live-betting-subtitle {
  font-size: 1rem;
  color: var(--text-muted);
  margin: 0;
}

.wallet-section-header {
  display: flex;
  gap: var(--spacing-sm);
}

.live-betting-title-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
}

.title-section {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
}

.wallet-section {
  display: flex;
  align-items: center;
  gap: 12px;
  background-color: var(--bg-card);
  border: 1px solid var(--border-primary);
  border-radius: var(--radius-md);
  padding: 12px 16px;
  box-shadow: var(--shadow-sm);
}

.wallet-info {
  display: flex;
  align-items: flex-end;
  gap: 0.25rem;
}

.wallet-label {
  font-size: 0.75rem;
  color: var(--text-secondary);
  font-weight: 500;
}

.wallet-balance {
  font-size: 1.25rem;
  font-weight: 700;
  color: var(--proskins-green);
}

.live-betting-title {
  font-size: 1.875rem;
  line-height: 2.25rem;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0;
}

.connection-status {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 12px;
  background-color: var(--bg-secondary);
  border: 1px solid var(--border-primary);
  border-radius: var(--radius-md);
  font-size: 0.875rem;
  font-weight: 500;
}

.connection-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  transition: all var(--transition-fast);
}

.connection-dot.connected {
  background-color: #10b981;
  box-shadow: 0 0 0 2px rgba(16, 185, 129, 0.2);
  animation: pulse-green 2s infinite;
}

.connection-dot.disconnected {
  background-color: #ef4444;
  box-shadow: 0 0 0 2px rgba(239, 68, 68, 0.2);
  animation: pulse-red 2s infinite;
}

.connection-text {
  color: var(--text-secondary);
  font-size: 0.875rem;
  font-weight: 500;
}

@keyframes pulse-green {
  0%, 100% {
    box-shadow: 0 0 0 2px rgba(16, 185, 129, 0.2);
  }
  50% {
    box-shadow: 0 0 0 4px rgba(16, 185, 129, 0.1);
  }
}

@keyframes pulse-red {
  0%, 100% {
    box-shadow: 0 0 0 2px rgba(239, 68, 68, 0.2);
  }
  50% {
    box-shadow: 0 0 0 4px rgba(239, 68, 68, 0.1);
  }
}

.live-betting-subtitle {
  margin-top: 8px;
  color: var(--text-secondary);
  font-size: 1rem;
  line-height: 1.5rem;
}

/* Tournament Selection Bar */
.tournament-selection-bar {
  background-color: var(--bg-card);
  border: 1px solid var(--border-primary);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-md);
  padding: 16px 24px;
  margin-bottom: 24px;
}

.tournament-selection-container {
  max-width: 100%;
}

.tournament-selection-title {
  font-size: 1rem;
  font-weight: 600;
  color: var(--text-primary);
  margin: 0 0 12px 0;
}

.tournament-list-horizontal {
  display: flex;
  gap: 12px;
  overflow-x: auto;
  padding-bottom: 4px;
}

.tournament-card-compact {
  background-color: var(--bg-secondary);
  border: 1px solid var(--border-primary);
  border-radius: var(--radius-md);
  padding: 12px 16px;
  cursor: pointer;
  transition: all var(--transition-fast);
  min-width: 200px;
  flex-shrink: 0;
  position: relative;
}

.tournament-card-compact:hover {
  border-color: var(--proskins-green);
  box-shadow: 0 2px 8px rgba(0, 255, 136, 0.1);
}

.tournament-card-compact.selected {
  border-color: var(--proskins-green);
  background-color: rgba(0, 255, 136, 0.05);
  box-shadow: 0 2px 8px rgba(0, 255, 136, 0.2);
}

.tournament-status-bar {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  border-radius: var(--radius-md) var(--radius-md) 0 0;
}

.tournament-card-compact.selected .tournament-status-bar {
  background-color: var(--proskins-green);
}

.tournament-name-compact {
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--text-primary);
  margin: 8px 0 0 0;
  line-height: 1.2;
}

.tournament-status {
  padding: 2px 6px;
  border-radius: var(--radius-sm);
  font-size: 0.625rem;
  font-weight: 600;
  text-transform: uppercase;
}

.tournament-status.active {
  background-color: rgba(16, 185, 129, 0.1);
  color: #10b981;
}

.tournament-status.draft {
  background-color: rgba(156, 163, 175, 0.1);
  color: #9ca3af;
}


/* Main Content Split Layout */
.main-content-split {
  display: grid;
  grid-template-columns: 60% 40%;
  gap: 24px;
  align-items: start;
}

.left-panel {
  display: flex;
  flex-direction: column;
}

.right-panel {
  display: flex;
  flex-direction: column;
}

/* Legacy Main Content Grid - Keep for compatibility */
.main-content-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
  align-items: start;
}

/* Tournament Selection */
.tournament-selection {
  background-color: var(--bg-card);
  border: 1px solid var(--border-primary);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-md);
  padding: 24px;
}

.tournament-selection-title {
  font-size: 1.25rem;
  font-weight: 600;
  color: var(--text-primary);
  margin: 0 0 16px 0;
}

.tournament-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.tournament-card {
  background-color: var(--bg-secondary);
  border: 1px solid var(--border-primary);
  border-radius: var(--radius-md);
  padding: 16px;
  cursor: pointer;
  transition: all var(--transition-fast);
}

.tournament-card:hover {
  border-color: var(--proskins-green);
  box-shadow: 0 2px 8px rgba(0, 255, 136, 0.1);
}

.tournament-card.selected {
  border-color: var(--proskins-green);
  background-color: rgba(0, 255, 136, 0.05);
  box-shadow: 0 2px 8px rgba(0, 255, 136, 0.2);
}

.tournament-name {
  font-size: 1rem;
  font-weight: 600;
  color: var(--text-primary);
  margin: 0 0 8px 0;
}

.tournament-description {
  font-size: 0.875rem;
  color: var(--text-secondary);
  margin: 0 0 12px 0;
  line-height: 1.4;
}

.tournament-meta {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.tournament-status {
  padding: 4px 8px;
  border-radius: var(--radius-sm);
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
}

.tournament-status.active {
  background-color: rgba(16, 185, 129, 0.1);
  color: #10b981;
}

.tournament-status.draft {
  background-color: rgba(156, 163, 175, 0.1);
  color: #9ca3af;
}

.tournament-pot {
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--proskins-green);
}

.tournament-dates {
  font-size: 0.75rem;
  color: var(--text-secondary);
}

/* Players Section */
.players-section {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.add-funds-button {
  background: linear-gradient(135deg, var(--proskins-green), var(--proskins-green-dark));
  color: var(--bg-primary);
  padding: 8px 16px;
  border-radius: var(--radius-md);
  border: none;
  font-weight: 600;
  cursor: pointer;
  transition: all var(--transition-fast);
  box-shadow: var(--shadow-sm);
}

.add-funds-button:hover {
  transform: translateY(-1px);
  box-shadow: var(--shadow-glow);
}


.tournament-dates {
  margin-top: 8px;
  font-size: 0.75rem;
  color: var(--text-muted);
}

/* Responsive Design - Match Homepage */
@media (max-width: 1024px) {
  .live-betting-main-content {
    width: calc(100% - 250px);
  }
  
  .live-betting-right-sidebar {
    width: 250px;
  }
  
  /* Responsive button sizing for smaller screens */
  .buy-button {
    min-width: 70px;
    height: 28px;
    font-size: 0.7rem;
    padding: 4px 8px;
  }
  
  .action-cell {
    width: 80px;
    min-width: 80px;
    padding: 6px 8px;
  }
}

@media (max-width: 768px) {
  .live-betting-layout {
    flex-direction: column;
  }
  
  .live-betting-main-content {
    width: 100%;
  }
  
  .live-betting-right-sidebar {
    width: 100%;
    border-left: none;
    border-bottom: 1px solid var(--border-primary);
  }
  
  .live-betting-title-section {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
  
  .wallet-section-header {
    align-items: flex-start;
    min-width: auto;
  }
}

/* Available Players */
.available-players-card {
  background-color: var(--bg-card);
  border: 1px solid var(--border-primary);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-md);
  padding: 24px;
}

.available-players-header {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 16px;
}

.tournament-started-banner {
  display: flex;
  align-items: center;
  gap: 8px;
  background: linear-gradient(135deg, #fef3c7, #fde68a);
  color: #92400e;
  padding: 12px 16px;
  border-radius: var(--radius-md);
  border: 1px solid #f59e0b;
  font-weight: 600;
  font-size: 0.875rem;
}

.banner-icon {
  font-size: 1rem;
}

.banner-text {
  flex: 1 1;
}

.tournament-started-indicator {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 32px;
  background-color: #2a2a2a;
  border-radius: 4px;
  border: 1px solid #444;
}

.started-text {
  color: #888;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
}

/* Available Players Table - Clean Home Page Style */
.available-players-table-container {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.available-players-table-wrapper {
  flex: 1 1;
  background-color: #1a1a1a;
  border-radius: 8px;
}

.available-players-table {
  width: 100%;
  border-collapse: collapse;
  background-color: #1a1a1a;
}

.available-players-table thead {
  background-color: #1a1a1a;
  position: sticky;
  top: 0;
  z-index: 10;
}

.available-players-table th {
  padding: 12px 16px;
  text-align: left;
  font-weight: 600;
  color: #ffffff;
  font-size: 0.875rem;
  border-bottom: 1px solid #333333;
}

.player-row {
  border-bottom: 1px solid #333333;
  background-color: #1a1a1a;
}

.player-row:hover {
  background-color: #2a2a2a;
}

.player-row:last-child {
  border-bottom: none;
}

.available-players-table td {
  padding: 12px;
  vertical-align: middle;
  font-size: 0.875rem;
}

.ranking-cell {
  width: 50px;
}

.ranking-number {
  color: #3ad640;
  font-weight: 600;
  font-size: 0.875rem;
}

.tier-cell {
  width: 60px;
  text-align: center;
}

.tier-badge {
  background-color: #fbbf24;
  color: #000000;
  padding: 4px 8px;
  font-size: 0.75rem;
  font-weight: 600;
  border-radius: 12px;
  text-transform: uppercase;
  display: inline-block;
}

.name-cell {
  color: #ffffff;
  font-weight: 500;
  min-width: 130px;
}

.action-cell {
  width: 100px;
  min-width: 100px;
  text-align: center;
  padding: 8px 12px;
  white-space: nowrap;
}

.buy-button {
  background-color: #3ad640;
  color: #000000;
  border: none;
  border-radius: 4px;
  padding: 6px 12px;
  font-size: 0.75rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 80px;
  height: 32px;
  text-transform: uppercase;
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
}

.buy-button.enabled:hover:not(:disabled) {
  background-color: #00cc6a;
  transform: translateY(-1px);
}

.buy-button.disabled {
  background-color: #2a2a2a;
  color: #888888;
  cursor: not-allowed;
  opacity: 0.6;
}

.taken-button {
  background-color: #2a2a2a;
  color: #888888;
  border: 1px solid #444444;
  border-radius: 4px;
  padding: 6px 12px;
  font-size: 0.75rem;
  font-weight: 600;
  cursor: not-allowed;
  opacity: 0.7;
  min-width: 80px;
  height: 32px;
  text-transform: uppercase;
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  transition: all 0.2s ease;
}

.available-players-title {
  font-size: 1.125rem;
  line-height: 1.75rem;
  font-weight: 600;
  color: var(--text-primary);
  margin: 0 0 16px 0;
}

.available-players-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-height: 384px;
  overflow-y: auto;
}

.player-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px;
  border: 1px solid var(--border-secondary);
  border-radius: var(--radius-md);
  background-color: var(--bg-tertiary);
  transition: all var(--transition-fast);
}

.player-item:hover {
  border-color: var(--border-accent);
  transform: translateY(-1px);
  box-shadow: var(--shadow-md);
}

.player-info {
  flex: 1 1;
}

.player-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 4px;
}

.player-name {
  font-weight: 500;
  color: var(--text-primary);
  margin: 0;
}

.tier-badge {
  padding: 2px 8px;
  font-size: 0.75rem;
  font-weight: 500;
  border-radius: 9999px;
}

.tier-a {
  background-color: #fbbf24;
  color: #000000;
}

.tier-b {
  background-color: #3b82f6;
  color: #ffffff;
}

.tier-c {
  background-color: #f97316;
  color: #ffffff;
}

.tier-d {
  background-color: #ef4444;
  color: #ffffff;
}

.player-details {
  margin-top: 4px;
  font-size: 0.875rem;
  color: var(--text-secondary);
}

.player-price-section {
  text-align: right;
}

.player-price {
  font-size: 1.125rem;
  line-height: 1.75rem;
  font-weight: 700;
  color: var(--proskins-green);
  margin: 0 0 4px 0;
}

.purchase-button {
  margin-top: 4px;
  padding: 4px 12px;
  font-size: 0.875rem;
  font-weight: 500;
  border-radius: 6px;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
}

.purchase-button.enabled {
  background: linear-gradient(135deg, var(--proskins-green), var(--proskins-green-dark));
  color: var(--bg-primary);
  border: none;
  box-shadow: var(--shadow-sm);
}

.purchase-button.enabled:hover {
  transform: translateY(-1px);
  box-shadow: var(--shadow-glow);
}

.purchase-button.disabled {
  background-color: var(--bg-tertiary);
  color: var(--text-muted);
  border: 1px solid var(--border-secondary);
  cursor: not-allowed;
}

/* My Players */
.my-players-card {
  background-color: var(--bg-card);
  border: 1px solid var(--border-primary);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-md);
  padding: 24px;
}

.my-players-title {
  font-size: 1.125rem;
  line-height: 1.75rem;
  font-weight: 600;
  color: var(--text-primary);
  margin: 0 0 16px 0;
}

.my-players-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-height: 384px;
  overflow-y: auto;
}

.my-player-item {
  padding: 12px;
  border: 1px solid var(--proskins-green);
  border-radius: var(--radius-md);
  background-color: rgba(0, 255, 136, 0.1);
  transition: all var(--transition-fast);
}

.my-player-item:hover {
  border-color: var(--proskins-green-dark);
  transform: translateY(-1px);
  box-shadow: var(--shadow-glow);
}

.my-player-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.my-player-info {
  flex: 1 1;
}

.my-player-name-section {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 4px;
}

.my-player-name {
  font-weight: 500;
  color: var(--text-primary);
  margin: 0;
}

.my-player-details {
  margin-top: 4px;
  font-size: 0.875rem;
  color: var(--text-secondary);
}

.my-player-purchase {
  margin-top: 4px;
  font-size: 0.875rem;
  color: var(--proskins-green);
  font-weight: 500;
}

.my-player-status {
  padding: 2px 8px;
  font-size: 0.75rem;
  font-weight: 500;
  border-radius: 9999px;
}

.my-player-status.active {
  background-color: rgba(0, 255, 136, 0.2);
  color: var(--proskins-green);
  border: 1px solid var(--proskins-green);
}

.my-player-status.inactive {
  background-color: var(--bg-tertiary);
  color: var(--text-muted);
  border: 1px solid var(--border-secondary);
}

/* Empty States */
.empty-state {
  text-align: center;
  padding: 32px 16px;
  color: var(--text-secondary);
}

.empty-state.no-tournaments {
  background-color: var(--bg-card);
  border: 1px solid var(--border-primary);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-md);
  padding: 24px;
}

.empty-state.no-players {
  padding: 32px 16px;
  color: var(--text-secondary);
}

.empty-state.no-tournament-selected {
  background-color: var(--bg-card);
  border: 1px solid var(--border-primary);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-md);
  padding: 24px;
  text-align: center;
  color: var(--text-secondary);
}

.empty-state-subtitle {
  margin-top: 8px;
  font-size: 0.875rem;
  color: var(--text-muted);
}

/* Loading State */
.loading-container {
  min-height: 100vh;
  background-color: var(--bg-primary);
  display: flex;
  align-items: center;
  justify-content: center;
}

.loading-content {
  text-align: center;
}

/* Live Betting loading spinner */
.live-betting-loading-spinner {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
}

.live-betting-spinner {
  animation: spin 1s linear infinite;
  border-radius: 50%;
  height: 48px;
  width: 48px;
  border-bottom: 2px solid var(--proskins-green);
  margin: 0 auto;
}

.loading-text {
  margin-top: 16px;
  color: var(--text-secondary);
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

/* Responsive Design */
@media (max-width: 640px) {
  .live-betting-container {
    padding: 16px;
  }
  
  .live-betting-title {
    font-size: 1.5rem;
  }
  
  .wallet-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }
  
  .tournament-grid {
    grid-template-columns: 1fr;
  }
  
  .players-grid {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/LiveBetting.css"],"names":[],"mappings":"AAAA,6BAA6B;;AAE7B,oDAAoD;AACpD;EACE,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;EACjB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,mCAAmC;EACnC,0BAA0B;EAC1B,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,qCAAqC;EACrC,4CAA4C;EAC5C,0BAA0B;EAC1B,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,uCAAuC;EACvC,+BAA+B;EAC/B,0BAA0B;EAC1B,eAAe;EACf,sCAAsC;EACtC,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,4CAA4C;AAC9C;;AAEA;EACE,mCAAmC;EACnC,yCAAyC;EACzC,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,0BAA0B;EAC1B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,YAAY;AACd;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,uCAAuC;EACvC,0CAA0C;AAC5C;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,0BAA0B;EAC1B,yCAAyC;EACzC,+BAA+B;EAC/B,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,cAAc;AAChB;;;;AAIA,WAAW;AACX;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gCAAgC;EAChC,uCAAuC;EACvC,+BAA+B;EAC/B,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,qCAAqC;EACrC,uCAAuC;EACvC,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;EACzB,6CAA6C;EAC7C,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;EACzB,4CAA4C;EAC5C,gCAAgC;AAClC;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE;IACE,6CAA6C;EAC/C;EACA;IACE,6CAA6C;EAC/C;AACF;;AAEA;EACE;IACE,4CAA4C;EAC9C;EACA;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,eAAe;EACf,mBAAmB;AACrB;;AAEA,6BAA6B;AAC7B;EACE,gCAAgC;EAChC,uCAAuC;EACvC,+BAA+B;EAC/B,4BAA4B;EAC5B,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;EACvC,+BAA+B;EAC/B,kBAAkB;EAClB,eAAe;EACf,sCAAsC;EACtC,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,4CAA4C;AAC9C;;AAEA;EACE,mCAAmC;EACnC,yCAAyC;EACzC,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,oDAAoD;AACtD;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,0BAA0B;EAC1B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,0CAA0C;EAC1C,cAAc;AAChB;;;AAGA,8BAA8B;AAC9B;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA,sDAAsD;AACtD;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;AACpB;;AAEA,yBAAyB;AACzB;EACE,gCAAgC;EAChC,uCAAuC;EACvC,+BAA+B;EAC/B,4BAA4B;EAC5B,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;EACvC,+BAA+B;EAC/B,aAAa;EACb,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,mCAAmC;EACnC,4CAA4C;AAC9C;;AAEA;EACE,mCAAmC;EACnC,yCAAyC;EACzC,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,sFAAsF;EACtF,wBAAwB;EACxB,iBAAiB;EACjB,+BAA+B;EAC/B,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,sCAAsC;EACtC,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;;;AAGA;EACE,eAAe;EACf,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA,uCAAuC;AACvC;EACE;IACE,yBAAyB;EAC3B;;EAEA;IACE,YAAY;EACd;;EAEA,iDAAiD;EACjD;IACE,eAAe;IACf,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,iBAAiB;IACjB,8CAA8C;EAChD;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,uBAAuB;IACvB,eAAe;EACjB;AACF;;AAEA,sBAAsB;AACtB;EACE,gCAAgC;EAChC,uCAAuC;EACvC,+BAA+B;EAC/B,4BAA4B;EAC5B,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,qDAAqD;EACrD,cAAc;EACd,kBAAkB;EAClB,+BAA+B;EAC/B,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA,oDAAoD;AACpD;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,MAAM;EACN,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,eAAe;EACf,YAAY;EACZ,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,yCAAyC;EACzC,+BAA+B;EAC/B,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,sFAAsF;EACtF,wBAAwB;EACxB,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,oCAAoC;EACpC,wBAAwB;EACxB,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE,gCAAgC;EAChC,uCAAuC;EACvC,+BAA+B;EAC/B,4BAA4B;EAC5B,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uCAAuC;EACvC,+BAA+B;EAC/B,wCAAwC;EACxC,sCAAsC;AACxC;;AAEA;EACE,wCAAwC;EACxC,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,wCAAwC;EACxC,4BAA4B;EAC5B,uCAAuC;AACzC;;AAEA;EACE,oCAAoC;EACpC,wBAAwB;EACxB,yCAAyC;AAC3C;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;EAChC,uCAAuC;EACvC,+BAA+B;EAC/B,4BAA4B;EAC5B,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;EAChC,uCAAuC;EACvC,+BAA+B;EAC/B,4BAA4B;EAC5B,aAAa;EACb,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA,kBAAkB;AAClB;EACE,iBAAiB;EACjB,mCAAmC;EACnC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,8CAA8C;EAC9C,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":["/* Live Betting Page Styles */\n\n/* Custom Layout Structure - Match Homepage Layout */\n.live-betting-layout {\n  display: flex;\n  min-height: calc(100vh - 80px);\n  max-width: 1600px;\n  margin: 0 auto;\n  width: 100%;\n}\n\n.live-betting-main-content {\n  width: calc(100% - 27rem);\n  background-color: var(--bg-primary);\n  padding: var(--spacing-lg);\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-lg);\n}\n\n.live-betting-right-sidebar {\n  width: 27rem;\n  background-color: var(--bg-secondary);\n  border-left: 1px solid var(--border-primary);\n  padding: var(--spacing-lg);\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-lg);\n}\n\n.tournament-selection-section {\n  flex-shrink: 0;\n}\n\n.available-players-section {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n}\n\n.tournament-list-vertical {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-sm);\n  flex: 1;\n  overflow-y: auto;\n}\n\n.tournament-card-sidebar {\n  background-color: var(--bg-card);\n  border: 1px solid var(--border-primary);\n  border-radius: var(--radius-md);\n  padding: var(--spacing-md);\n  cursor: pointer;\n  transition: all var(--transition-fast);\n  position: relative;\n}\n\n.tournament-card-sidebar:hover {\n  border-color: var(--proskins-green);\n  box-shadow: 0 2px 8px rgba(0, 255, 136, 0.1);\n}\n\n.tournament-card-sidebar.selected {\n  border-color: var(--proskins-green);\n  background-color: rgba(0, 255, 136, 0.05);\n  box-shadow: 0 2px 8px rgba(0, 255, 136, 0.2);\n}\n\n.tournament-name-sidebar {\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: var(--text-primary);\n  margin: 8px 0 0 0;\n  line-height: 1.2;\n}\n\n/* Main Content Styles */\n.live-betting-main {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-lg);\n  height: 100%;\n}\n\n/* Connection Status Styles */\n.connection-status {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  margin: 0 1rem;\n}\n\n.connection-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  transition: all var(--transition-fast);\n}\n\n.connection-dot.connected {\n  background-color: var(--proskins-green);\n  box-shadow: 0 0 8px rgba(0, 255, 136, 0.5);\n}\n\n.connection-dot.disconnected {\n  background-color: var(--text-muted);\n}\n\n.connection-text {\n  font-size: 0.75rem;\n  font-weight: 500;\n  color: var(--text-secondary);\n}\n\n/* Right Sidebar Styles */\n.available-players-sidebar {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-md);\n  height: 100%;\n}\n\n.available-players-list {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-sm);\n  flex: 1;\n  overflow-y: auto;\n}\n\n.player-item-sidebar {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-sm);\n  padding: var(--spacing-md);\n  border: 1px solid var(--border-secondary);\n  border-radius: var(--radius-md);\n  background-color: var(--bg-tertiary);\n  transition: all var(--transition-fast);\n}\n\n.player-item-sidebar:hover {\n  border-color: var(--border-accent);\n  transform: translateY(-1px);\n  box-shadow: var(--shadow-md);\n}\n\n.player-item-sidebar .player-info {\n  flex: 1;\n}\n\n.player-item-sidebar .player-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 4px;\n}\n\n.player-item-sidebar .player-name {\n  font-weight: 500;\n  color: var(--text-primary);\n  margin: 0;\n  font-size: 0.875rem;\n}\n\n.player-item-sidebar .player-details {\n  font-size: 0.75rem;\n  color: var(--text-secondary);\n  margin-bottom: var(--spacing-sm);\n}\n\n.player-item-sidebar .player-price-section {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: var(--spacing-sm);\n}\n\n.player-item-sidebar .player-price {\n  font-size: 1rem;\n  font-weight: 700;\n  color: var(--proskins-green);\n}\n\n.player-item-sidebar .purchase-button {\n  padding: 6px 12px;\n  font-size: 0.75rem;\n  font-weight: 500;\n  border-radius: 6px;\n  border: none;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  flex-shrink: 0;\n}\n\n\n\n/* Header */\n.live-betting-header {\n  margin-bottom: 0;\n}\n\n.live-betting-title-section {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: var(--spacing-lg);\n}\n\n.live-betting-title-left {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-sm);\n}\n\n.live-betting-title {\n  font-size: 2rem;\n  font-weight: 700;\n  color: var(--text-primary);\n  margin: 0;\n}\n\n.live-betting-subtitle {\n  font-size: 1rem;\n  color: var(--text-muted);\n  margin: 0;\n}\n\n.wallet-section-header {\n  display: flex;\n  gap: var(--spacing-sm);\n}\n\n.live-betting-title-container {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n\n.title-section {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n\n.wallet-section {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  background-color: var(--bg-card);\n  border: 1px solid var(--border-primary);\n  border-radius: var(--radius-md);\n  padding: 12px 16px;\n  box-shadow: var(--shadow-sm);\n}\n\n.wallet-info {\n  display: flex;\n  align-items: flex-end;\n  gap: 0.25rem;\n}\n\n.wallet-label {\n  font-size: 0.75rem;\n  color: var(--text-secondary);\n  font-weight: 500;\n}\n\n.wallet-balance {\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: var(--proskins-green);\n}\n\n.live-betting-title {\n  font-size: 1.875rem;\n  line-height: 2.25rem;\n  font-weight: 700;\n  color: var(--text-primary);\n  margin: 0;\n}\n\n.connection-status {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 6px 12px;\n  background-color: var(--bg-secondary);\n  border: 1px solid var(--border-primary);\n  border-radius: var(--radius-md);\n  font-size: 0.875rem;\n  font-weight: 500;\n}\n\n.connection-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  transition: all var(--transition-fast);\n}\n\n.connection-dot.connected {\n  background-color: #10b981;\n  box-shadow: 0 0 0 2px rgba(16, 185, 129, 0.2);\n  animation: pulse-green 2s infinite;\n}\n\n.connection-dot.disconnected {\n  background-color: #ef4444;\n  box-shadow: 0 0 0 2px rgba(239, 68, 68, 0.2);\n  animation: pulse-red 2s infinite;\n}\n\n.connection-text {\n  color: var(--text-secondary);\n  font-size: 0.875rem;\n  font-weight: 500;\n}\n\n@keyframes pulse-green {\n  0%, 100% {\n    box-shadow: 0 0 0 2px rgba(16, 185, 129, 0.2);\n  }\n  50% {\n    box-shadow: 0 0 0 4px rgba(16, 185, 129, 0.1);\n  }\n}\n\n@keyframes pulse-red {\n  0%, 100% {\n    box-shadow: 0 0 0 2px rgba(239, 68, 68, 0.2);\n  }\n  50% {\n    box-shadow: 0 0 0 4px rgba(239, 68, 68, 0.1);\n  }\n}\n\n.live-betting-subtitle {\n  margin-top: 8px;\n  color: var(--text-secondary);\n  font-size: 1rem;\n  line-height: 1.5rem;\n}\n\n/* Tournament Selection Bar */\n.tournament-selection-bar {\n  background-color: var(--bg-card);\n  border: 1px solid var(--border-primary);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-md);\n  padding: 16px 24px;\n  margin-bottom: 24px;\n}\n\n.tournament-selection-container {\n  max-width: 100%;\n}\n\n.tournament-selection-title {\n  font-size: 1rem;\n  font-weight: 600;\n  color: var(--text-primary);\n  margin: 0 0 12px 0;\n}\n\n.tournament-list-horizontal {\n  display: flex;\n  gap: 12px;\n  overflow-x: auto;\n  padding-bottom: 4px;\n}\n\n.tournament-card-compact {\n  background-color: var(--bg-secondary);\n  border: 1px solid var(--border-primary);\n  border-radius: var(--radius-md);\n  padding: 12px 16px;\n  cursor: pointer;\n  transition: all var(--transition-fast);\n  min-width: 200px;\n  flex-shrink: 0;\n  position: relative;\n}\n\n.tournament-card-compact:hover {\n  border-color: var(--proskins-green);\n  box-shadow: 0 2px 8px rgba(0, 255, 136, 0.1);\n}\n\n.tournament-card-compact.selected {\n  border-color: var(--proskins-green);\n  background-color: rgba(0, 255, 136, 0.05);\n  box-shadow: 0 2px 8px rgba(0, 255, 136, 0.2);\n}\n\n.tournament-status-bar {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 4px;\n  border-radius: var(--radius-md) var(--radius-md) 0 0;\n}\n\n.tournament-card-compact.selected .tournament-status-bar {\n  background-color: var(--proskins-green);\n}\n\n.tournament-name-compact {\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: var(--text-primary);\n  margin: 8px 0 0 0;\n  line-height: 1.2;\n}\n\n.tournament-status {\n  padding: 2px 6px;\n  border-radius: var(--radius-sm);\n  font-size: 0.625rem;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n\n.tournament-status.active {\n  background-color: rgba(16, 185, 129, 0.1);\n  color: #10b981;\n}\n\n.tournament-status.draft {\n  background-color: rgba(156, 163, 175, 0.1);\n  color: #9ca3af;\n}\n\n\n/* Main Content Split Layout */\n.main-content-split {\n  display: grid;\n  grid-template-columns: 60% 40%;\n  gap: 24px;\n  align-items: start;\n}\n\n.left-panel {\n  display: flex;\n  flex-direction: column;\n}\n\n.right-panel {\n  display: flex;\n  flex-direction: column;\n}\n\n/* Legacy Main Content Grid - Keep for compatibility */\n.main-content-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 24px;\n  align-items: start;\n}\n\n/* Tournament Selection */\n.tournament-selection {\n  background-color: var(--bg-card);\n  border: 1px solid var(--border-primary);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-md);\n  padding: 24px;\n}\n\n.tournament-selection-title {\n  font-size: 1.25rem;\n  font-weight: 600;\n  color: var(--text-primary);\n  margin: 0 0 16px 0;\n}\n\n.tournament-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.tournament-card {\n  background-color: var(--bg-secondary);\n  border: 1px solid var(--border-primary);\n  border-radius: var(--radius-md);\n  padding: 16px;\n  cursor: pointer;\n  transition: all var(--transition-fast);\n}\n\n.tournament-card:hover {\n  border-color: var(--proskins-green);\n  box-shadow: 0 2px 8px rgba(0, 255, 136, 0.1);\n}\n\n.tournament-card.selected {\n  border-color: var(--proskins-green);\n  background-color: rgba(0, 255, 136, 0.05);\n  box-shadow: 0 2px 8px rgba(0, 255, 136, 0.2);\n}\n\n.tournament-name {\n  font-size: 1rem;\n  font-weight: 600;\n  color: var(--text-primary);\n  margin: 0 0 8px 0;\n}\n\n.tournament-description {\n  font-size: 0.875rem;\n  color: var(--text-secondary);\n  margin: 0 0 12px 0;\n  line-height: 1.4;\n}\n\n.tournament-meta {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 8px;\n}\n\n.tournament-status {\n  padding: 4px 8px;\n  border-radius: var(--radius-sm);\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n\n.tournament-status.active {\n  background-color: rgba(16, 185, 129, 0.1);\n  color: #10b981;\n}\n\n.tournament-status.draft {\n  background-color: rgba(156, 163, 175, 0.1);\n  color: #9ca3af;\n}\n\n.tournament-pot {\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: var(--proskins-green);\n}\n\n.tournament-dates {\n  font-size: 0.75rem;\n  color: var(--text-secondary);\n}\n\n/* Players Section */\n.players-section {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.add-funds-button {\n  background: linear-gradient(135deg, var(--proskins-green), var(--proskins-green-dark));\n  color: var(--bg-primary);\n  padding: 8px 16px;\n  border-radius: var(--radius-md);\n  border: none;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all var(--transition-fast);\n  box-shadow: var(--shadow-sm);\n}\n\n.add-funds-button:hover {\n  transform: translateY(-1px);\n  box-shadow: var(--shadow-glow);\n}\n\n\n.tournament-dates {\n  margin-top: 8px;\n  font-size: 0.75rem;\n  color: var(--text-muted);\n}\n\n/* Responsive Design - Match Homepage */\n@media (max-width: 1024px) {\n  .live-betting-main-content {\n    width: calc(100% - 250px);\n  }\n  \n  .live-betting-right-sidebar {\n    width: 250px;\n  }\n  \n  /* Responsive button sizing for smaller screens */\n  .buy-button {\n    min-width: 70px;\n    height: 28px;\n    font-size: 0.7rem;\n    padding: 4px 8px;\n  }\n  \n  .action-cell {\n    width: 80px;\n    min-width: 80px;\n    padding: 6px 8px;\n  }\n}\n\n@media (max-width: 768px) {\n  .live-betting-layout {\n    flex-direction: column;\n  }\n  \n  .live-betting-main-content {\n    width: 100%;\n  }\n  \n  .live-betting-right-sidebar {\n    width: 100%;\n    border-left: none;\n    border-bottom: 1px solid var(--border-primary);\n  }\n  \n  .live-betting-title-section {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 12px;\n  }\n  \n  .wallet-section-header {\n    align-items: flex-start;\n    min-width: auto;\n  }\n}\n\n/* Available Players */\n.available-players-card {\n  background-color: var(--bg-card);\n  border: 1px solid var(--border-primary);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-md);\n  padding: 24px;\n}\n\n.available-players-header {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  margin-bottom: 16px;\n}\n\n.tournament-started-banner {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  background: linear-gradient(135deg, #fef3c7, #fde68a);\n  color: #92400e;\n  padding: 12px 16px;\n  border-radius: var(--radius-md);\n  border: 1px solid #f59e0b;\n  font-weight: 600;\n  font-size: 0.875rem;\n}\n\n.banner-icon {\n  font-size: 1rem;\n}\n\n.banner-text {\n  flex: 1;\n}\n\n.tournament-started-indicator {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 32px;\n  background-color: #2a2a2a;\n  border-radius: 4px;\n  border: 1px solid #444;\n}\n\n.started-text {\n  color: #888;\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n\n/* Available Players Table - Clean Home Page Style */\n.available-players-table-container {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.available-players-table-wrapper {\n  flex: 1;\n  background-color: #1a1a1a;\n  border-radius: 8px;\n}\n\n.available-players-table {\n  width: 100%;\n  border-collapse: collapse;\n  background-color: #1a1a1a;\n}\n\n.available-players-table thead {\n  background-color: #1a1a1a;\n  position: sticky;\n  top: 0;\n  z-index: 10;\n}\n\n.available-players-table th {\n  padding: 12px 16px;\n  text-align: left;\n  font-weight: 600;\n  color: #ffffff;\n  font-size: 0.875rem;\n  border-bottom: 1px solid #333333;\n}\n\n.player-row {\n  border-bottom: 1px solid #333333;\n  background-color: #1a1a1a;\n}\n\n.player-row:hover {\n  background-color: #2a2a2a;\n}\n\n.player-row:last-child {\n  border-bottom: none;\n}\n\n.available-players-table td {\n  padding: 12px;\n  vertical-align: middle;\n  font-size: 0.875rem;\n}\n\n.ranking-cell {\n  width: 50px;\n}\n\n.ranking-number {\n  color: #3ad640;\n  font-weight: 600;\n  font-size: 0.875rem;\n}\n\n.tier-cell {\n  width: 60px;\n  text-align: center;\n}\n\n.tier-badge {\n  background-color: #fbbf24;\n  color: #000000;\n  padding: 4px 8px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  border-radius: 12px;\n  text-transform: uppercase;\n  display: inline-block;\n}\n\n.name-cell {\n  color: #ffffff;\n  font-weight: 500;\n  min-width: 130px;\n}\n\n.action-cell {\n  width: 100px;\n  min-width: 100px;\n  text-align: center;\n  padding: 8px 12px;\n  white-space: nowrap;\n}\n\n.buy-button {\n  background-color: #3ad640;\n  color: #000000;\n  border: none;\n  border-radius: 4px;\n  padding: 6px 12px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  min-width: 80px;\n  height: 32px;\n  text-transform: uppercase;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  white-space: nowrap;\n}\n\n.buy-button.enabled:hover:not(:disabled) {\n  background-color: #00cc6a;\n  transform: translateY(-1px);\n}\n\n.buy-button.disabled {\n  background-color: #2a2a2a;\n  color: #888888;\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n.taken-button {\n  background-color: #2a2a2a;\n  color: #888888;\n  border: 1px solid #444444;\n  border-radius: 4px;\n  padding: 6px 12px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  cursor: not-allowed;\n  opacity: 0.7;\n  min-width: 80px;\n  height: 32px;\n  text-transform: uppercase;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  white-space: nowrap;\n  transition: all 0.2s ease;\n}\n\n.available-players-title {\n  font-size: 1.125rem;\n  line-height: 1.75rem;\n  font-weight: 600;\n  color: var(--text-primary);\n  margin: 0 0 16px 0;\n}\n\n.available-players-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  max-height: 384px;\n  overflow-y: auto;\n}\n\n.player-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px;\n  border: 1px solid var(--border-secondary);\n  border-radius: var(--radius-md);\n  background-color: var(--bg-tertiary);\n  transition: all var(--transition-fast);\n}\n\n.player-item:hover {\n  border-color: var(--border-accent);\n  transform: translateY(-1px);\n  box-shadow: var(--shadow-md);\n}\n\n.player-info {\n  flex: 1;\n}\n\n.player-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 4px;\n}\n\n.player-name {\n  font-weight: 500;\n  color: var(--text-primary);\n  margin: 0;\n}\n\n.tier-badge {\n  padding: 2px 8px;\n  font-size: 0.75rem;\n  font-weight: 500;\n  border-radius: 9999px;\n}\n\n.tier-a {\n  background-color: #fbbf24;\n  color: #000000;\n}\n\n.tier-b {\n  background-color: #3b82f6;\n  color: #ffffff;\n}\n\n.tier-c {\n  background-color: #f97316;\n  color: #ffffff;\n}\n\n.tier-d {\n  background-color: #ef4444;\n  color: #ffffff;\n}\n\n.player-details {\n  margin-top: 4px;\n  font-size: 0.875rem;\n  color: var(--text-secondary);\n}\n\n.player-price-section {\n  text-align: right;\n}\n\n.player-price {\n  font-size: 1.125rem;\n  line-height: 1.75rem;\n  font-weight: 700;\n  color: var(--proskins-green);\n  margin: 0 0 4px 0;\n}\n\n.purchase-button {\n  margin-top: 4px;\n  padding: 4px 12px;\n  font-size: 0.875rem;\n  font-weight: 500;\n  border-radius: 6px;\n  border: none;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.purchase-button.enabled {\n  background: linear-gradient(135deg, var(--proskins-green), var(--proskins-green-dark));\n  color: var(--bg-primary);\n  border: none;\n  box-shadow: var(--shadow-sm);\n}\n\n.purchase-button.enabled:hover {\n  transform: translateY(-1px);\n  box-shadow: var(--shadow-glow);\n}\n\n.purchase-button.disabled {\n  background-color: var(--bg-tertiary);\n  color: var(--text-muted);\n  border: 1px solid var(--border-secondary);\n  cursor: not-allowed;\n}\n\n/* My Players */\n.my-players-card {\n  background-color: var(--bg-card);\n  border: 1px solid var(--border-primary);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-md);\n  padding: 24px;\n}\n\n.my-players-title {\n  font-size: 1.125rem;\n  line-height: 1.75rem;\n  font-weight: 600;\n  color: var(--text-primary);\n  margin: 0 0 16px 0;\n}\n\n.my-players-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  max-height: 384px;\n  overflow-y: auto;\n}\n\n.my-player-item {\n  padding: 12px;\n  border: 1px solid var(--proskins-green);\n  border-radius: var(--radius-md);\n  background-color: rgba(0, 255, 136, 0.1);\n  transition: all var(--transition-fast);\n}\n\n.my-player-item:hover {\n  border-color: var(--proskins-green-dark);\n  transform: translateY(-1px);\n  box-shadow: var(--shadow-glow);\n}\n\n.my-player-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.my-player-info {\n  flex: 1;\n}\n\n.my-player-name-section {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 4px;\n}\n\n.my-player-name {\n  font-weight: 500;\n  color: var(--text-primary);\n  margin: 0;\n}\n\n.my-player-details {\n  margin-top: 4px;\n  font-size: 0.875rem;\n  color: var(--text-secondary);\n}\n\n.my-player-purchase {\n  margin-top: 4px;\n  font-size: 0.875rem;\n  color: var(--proskins-green);\n  font-weight: 500;\n}\n\n.my-player-status {\n  padding: 2px 8px;\n  font-size: 0.75rem;\n  font-weight: 500;\n  border-radius: 9999px;\n}\n\n.my-player-status.active {\n  background-color: rgba(0, 255, 136, 0.2);\n  color: var(--proskins-green);\n  border: 1px solid var(--proskins-green);\n}\n\n.my-player-status.inactive {\n  background-color: var(--bg-tertiary);\n  color: var(--text-muted);\n  border: 1px solid var(--border-secondary);\n}\n\n/* Empty States */\n.empty-state {\n  text-align: center;\n  padding: 32px 16px;\n  color: var(--text-secondary);\n}\n\n.empty-state.no-tournaments {\n  background-color: var(--bg-card);\n  border: 1px solid var(--border-primary);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-md);\n  padding: 24px;\n}\n\n.empty-state.no-players {\n  padding: 32px 16px;\n  color: var(--text-secondary);\n}\n\n.empty-state.no-tournament-selected {\n  background-color: var(--bg-card);\n  border: 1px solid var(--border-primary);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-md);\n  padding: 24px;\n  text-align: center;\n  color: var(--text-secondary);\n}\n\n.empty-state-subtitle {\n  margin-top: 8px;\n  font-size: 0.875rem;\n  color: var(--text-muted);\n}\n\n/* Loading State */\n.loading-container {\n  min-height: 100vh;\n  background-color: var(--bg-primary);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.loading-content {\n  text-align: center;\n}\n\n/* Live Betting loading spinner */\n.live-betting-loading-spinner {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 2rem;\n}\n\n.live-betting-spinner {\n  animation: spin 1s linear infinite;\n  border-radius: 50%;\n  height: 48px;\n  width: 48px;\n  border-bottom: 2px solid var(--proskins-green);\n  margin: 0 auto;\n}\n\n.loading-text {\n  margin-top: 16px;\n  color: var(--text-secondary);\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* Responsive Design */\n@media (max-width: 640px) {\n  .live-betting-container {\n    padding: 16px;\n  }\n  \n  .live-betting-title {\n    font-size: 1.5rem;\n  }\n  \n  .wallet-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 16px;\n  }\n  \n  .tournament-grid {\n    grid-template-columns: 1fr;\n  }\n  \n  .players-grid {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
